import React from "react";
import { FormControl } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import "./TimeRegistrationUbicationSelect.scss";

/**
 * Selector de ubicación de fichaje con aspecto de píldora (nativo select estilizado).
 */
const TimeRegistrationUbicationSelect = ({
	id,
	value,
	disabled,
	options,
	onChange,
}) => {
	const { t } = useTranslation();
	return (
		<div className="time-registration-ubication-select-wrap">
			<FormControl
				id={id}
				disabled={disabled}
				className="time-registration-ubication-select"
				as="select"
				value={value}
				onChange={onChange}
			>
				<option value="-1">{t("times.selectUbication")}</option>
				{options.map((opt) => (
					<option key={opt.id} value={opt.id}>
						{opt.name}
					</option>
				))}
			</FormControl>
		</div>
	);
};

export default TimeRegistrationUbicationSelect;
